module.exports = __webpack_public_path__ + "img/museu.2aa45a4e.png";